import GLightbox from '../vendor/glightbox/script';

GLightbox();
